import React, { useState } from "react";
import { toast } from "sonner";
import { Sheet } from "@/pages/Familia";
import { useData } from "@/context/DataContext";
import { catLabel } from "@/mock/data";
import { formatApiErrorDetail } from "@/lib/api";

const CATEGORIAS = ["Hogar", "Vehículos", "Contratos y seguros", "Mascotas", "Otros"];
const campo = "w-full min-h-[52px] rounded-xl border border-[#E5DFD5] bg-white px-4 text-base text-[#1C2421]";

// Edición de un asunto creado a mano: título, categoría y notas.
export const EditarAsunto = ({ matter, onClose }) => {
  const { editarAsunto } = useData();
  const [f, setF] = useState({ title: matter.title || "", category: CATEGORIAS.includes(matter.category) ? matter.category : "Otros", notes: matter.summary || "" });
  const [busy, setBusy] = useState(false);
  const guardar = async () => {
    if (!f.title.trim()) return toast.error("Indica un título.");
    setBusy(true);
    try {
      await editarAsunto(matter.id, f);
      toast.success("Asunto actualizado");
      onClose();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "No se pudo guardar.");
      setBusy(false);
    }
  };
  return (
    <Sheet onClose={onClose} testid="asunto-editar">
      <h2 className="font-heading text-2xl font-bold text-[#1C2421] pr-12">Editar asunto</h2>
      <div className="space-y-4 mt-5">
        <label className="block"><span className="text-base font-semibold text-[#1C2421]">Título</span>
          <input data-testid="asunto-editar-titulo" value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} className={`${campo} mt-1.5`} /></label>
        <label className="block"><span className="text-base font-semibold text-[#1C2421]">Categoría</span>
          <select data-testid="asunto-editar-categoria" value={f.category} onChange={(e) => setF({ ...f, category: e.target.value })} className={`${campo} mt-1.5`}>
            {CATEGORIAS.map((c) => <option key={c} value={c}>{catLabel(c)}</option>)}
          </select></label>
        <label className="block"><span className="text-base font-semibold text-[#1C2421]">Notas</span>
          <textarea data-testid="asunto-editar-notas" rows={4} value={f.notes} onChange={(e) => setF({ ...f, notes: e.target.value })} className={`${campo} mt-1.5 py-3`} /></label>
      </div>
      <div className="grid grid-cols-2 gap-3 mt-6">
        <button data-testid="asunto-editar-cancelar" onClick={onClose} className="min-h-[52px] rounded-xl border border-[#E5DFD5] bg-white font-semibold">Cancelar</button>
        <button data-testid="asunto-editar-guardar" disabled={busy} onClick={guardar} className="min-h-[52px] rounded-xl bg-[#3A6B56] text-white font-semibold disabled:opacity-60">{busy ? "Guardando…" : "Guardar cambios"}</button>
      </div>
    </Sheet>
  );
};
